import React, { useMemo, useState } from 'react';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from 'styled-components';
import { ThemeProviderProps } from './theme-types';
import { ThemeContext } from './context';
import palettes from './config/palleteConfig';

export const ThemeContextProvider: React.FC<ThemeProviderProps> = ({ children }) => {
    const [isDark, setIsDark] = useState(true);
    const theme = isDark ? palettes.dark : palettes.light;

    const value = useMemo(() => ({ 
        theme,
        isDark,
        setTheme: setIsDark
    }), [theme, isDark]);

    return (
        <ThemeContext.Provider value={value}>
            <ConfigProvider
                theme={{
                    token: {
                        colorBgBase: theme.colors.theme.appBg,
                        colorTextBase: theme.colors.text.headings,
                        colorPrimary: theme.colors.theme.brandColor3,
                        colorBgSpotlight: theme.colors.theme.contentBgOpaque,
                        colorBorder: theme.colors.text.neutral,
                    }
                }}
            >
                <ThemeProvider theme={theme}>
                    {children}
                </ThemeProvider>
            </ConfigProvider>
        </ThemeContext.Provider>
    );
};

